import { useGetMyPlanQuery } from '@/entities/custom-pricing'
import { FREE_PLAN_ENDED_MESSAGE, isFreePlanEnded } from '@/lib/access'
import { useAppSelector } from '@/shared/lib'
import { SubscriptionOptions } from '@/features/subscriptions'
import { Button, Dialog } from '@/shared/ui'
import { useState } from 'react'
import { StyledHeading, StyledTypography } from '../ChoosePlanPage/styles'
import { ButtonsWrapper, Content } from './styles'

// Custom-priced customers get no free trial, so the standard trial copy every
// call site passes in would be wrong for them.
const CUSTOM_PLAN_DESCRIPTION =
	'You currently do not have an active subscription. Your organization has negotiated custom pricing — review the agreed terms and subscribe to activate it.'

const CUSTOM_PLAN_STEP_TWO_DESCRIPTION =
	"These are the terms agreed for your organization. Subscribe to activate them and regain access to FortunAI's features."

interface IProps {
	title: string
	description: string
	isOpen: boolean
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ChoosePlanModal = ({
	title,
	description,
	isOpen,
	setIsOpen
}: IProps) => {
	const [step, setStep] = useState<1 | 2>(1)
	const { data: myPlan } = useGetMyPlanQuery(undefined, { skip: !isOpen })

	const { user: currentUser } = useAppSelector((state) => state.currentUser)

	const isCustom = myPlan?.isCustom === true

	return (
		<Dialog
			open={isOpen}
			onOpenChange={(open) => {
				setStep(1)
				setIsOpen(open)
			}}
		>
			<Content preventOutsideClick={true}>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
					{step === 1 && (
						<>
							<StyledHeading variant='h2' weight='bold'>
								{title}
							</StyledHeading>
							<StyledTypography>
								{isCustom
									? CUSTOM_PLAN_DESCRIPTION
									: isFreePlanEnded(currentUser)
									? FREE_PLAN_ENDED_MESSAGE
									: description}
							</StyledTypography>

							<ButtonsWrapper>
								<Dialog.Close>
									<Button fullWidth variant='secondary' label='Cancel' />
								</Dialog.Close>

								<Button
									label={isCustom ? 'View my plan' : 'Upgrade Subscription'}
									onClick={async () => {
										setStep(2)
									}}
									fullWidth
								/>
							</ButtonsWrapper>
						</>
					)}

					{step === 2 && (
						<>
							<Dialog.Close />
							<StyledHeading variant='h2' weight='bold'>
								{isCustom
									? 'Your negotiated plan'
									: 'Choose a Plan to Continue'}
							</StyledHeading>
							<StyledTypography>
								{isCustom
									? CUSTOM_PLAN_STEP_TWO_DESCRIPTION
									: "To access FortunAI's features, you'll need to select a plan that fits your business. Pick the one that works best for you — no access is granted without an active subscription."}
							</StyledTypography>
							<SubscriptionOptions />
						</>
					)}
				</div>
			</Content>
		</Dialog>
	)
}
